const clusterColumns = [
  { Header: 'Cluster', accessor: 'name' },
  { Header: 'Location', accessor: 'location' },
  { Header: 'Storage Policy', accessor: 'storage_policy' },
  { Header: 'Node count', accessor: 'node_count'},
  { Header: 'Node size', accessor: 'node_size' },
  { Header: 'Raw Total TB', accessor: 'raw_total_tb' },
  { Header: 'Reserved TB (10%)', accessor: 'reserved_tb' },
  { Header: 'Usable TB', accessor: 'usable_tb' },
  { Header: 'Used TB', accessor: 'space_info.disk_used' },
  { Header: 'Free TB', accessor: 'space_info.disk_avail' },
  { Header: 'Used % of Usable', accessor: 'used_percent_of_usable', rag: true, ragLimits: { red: 90, amber: 80 }, type: 'percent', valueIsSmaller: false },
  { Header: 'Free % of Usable', accessor: 'free_percent_of_usable', rag: true, ragLimits: { red: 10, amber: 20 }, type: 'percent' },
  { Header: 'Used % of total', accessor: 'used_percent_of_total', rag: true, ragLimits: { red: 90, amber: 80 }, type: 'percent', valueIsSmaller: false },
  { Header: 'Free % of total', accessor: 'free_percent_of_total', rag: true, ragLimits: { red: 10, amber: 20 }, type: 'percent' },
  { Header: 'Free TB until 80%', accessor: 'free_tb_until_80_percent' },
  { Header: 'Data capacity total TB', accessor: 'data_capacity_total'},
  { Header: 'Data size stored TB', accessor: 'data_size_stored'},
  { Header: 'Data storage free TB', accessor: 'data_storage_free'}
]

const nodesColumns = [
  { Header: 'Node', accessor: 'name' },
  { Header: 'Status', accessor: 'status' },
  { Header: 'Disk free TB', accessor: 'disk_avail' },
  { Header: 'Disk used TB', accessor: 'disk_used' },
  { Header: 'Disk total TB', accessor: 'disk_total' }
]

const chartColumns = [
  { label: 'Node count', accessor: 'node_count'},
  { label: 'Used TB', accessor: 'used_tb' },
  { label: 'Free TB', accessor: 'free_tb' },
  { label: 'Used % of Usable', accessor: 'used_percent_of_usable' },
  { label: 'Free % of Usable', accessor: 'free_percent_of_usable' },
  { label: 'Used % of total', accessor: 'used_percent_of_total' },
  { label: 'Free % of total', accessor: 'free_percent_of_total' },
  { label: 'Free TB until 80%', accessor: 'free_tb_until_80_percent' },
  { label: 'Data capacity total TB', accessor: 'data_capacity_total'},
  { label: 'Data size stored TB', accessor: 'data_size_stored'},
  { label: 'Data storage free TB', accessor: 'data_storage_free'}
]

export { clusterColumns, nodesColumns, chartColumns }